import { Tooltip } from "react-tooltip";
import {
  IBenefit,
  IHealthPlan,
  IPlanDetailsOurData,
  IPriceTile,
} from "../../interfaces/api";
import { EnrollTooltip } from "../../shared";
import PriceTile from "../../shared/AlignmentTile/PriceTile.component";
import { useZipRootLoaderData } from "../../hooks/useZipRootLoaderData";
import { useEnrollLink } from "../../hooks/useEnrollLink";

const HeaderDetails = ({ data }: { data: IPlanDetailsOurData[] }) => {
  const { yearsForZip } = useZipRootLoaderData();
  const enrollLink = useEnrollLink(
    data[0].company[0].healthPlan[0].pbp[0].id,
    data[0].company[0].healthPlan[0].hCode,
    `${data[0].planYear}`
  );
  const getMonthlyPlan = (data: IHealthPlan) => {
    let partB: IBenefit[] = [];

    data.pbp[0].group.forEach((group) => {
      if (group.pbpBenefitGroup === ("Premiums and Benefits" as string)) {
        group.category.forEach((category) => {
          if (
            category.pbpBenefitCategory === ("Monthly Plan Premium" as string)
          ) {
            partB = category.benefit;
          }
        });
      }
    });

    return partB;
  };

  const monthly = getMonthlyPlan(data[0].company[0].healthPlan[0]);

  const pbpBenefitDesc = monthly[0].pbpBenefitDesc;
  const [price, rest] =
    typeof pbpBenefitDesc === "string"
      ? pbpBenefitDesc
          .replace(/\\*\\n/g, "\n")
          .replace(/\\/g, "")
          .split("\n")
      : ["-", ""];

  const object1 = {
    pbpBenefitDesc: price,
  };

  const object2 = {
    pbpBenefitDesc: rest,
  };

  const monthlyArray = [object1, object2];

  const priceTilesData: IPriceTile[] = [
    {
      label: "Monthly Premium",
      // value: monthly[0].pbpBenefitDesc ? monthly[0].pbpBenefitDesc : "No Data",
      value: monthly[0].pbpBenefitDesc
        ? monthlyArray[0].pbpBenefitDesc
        : "No Data",
      desc: monthly[0].pbpBenefitDesc
        ? monthlyArray[1].pbpBenefitDesc
        : "No Data",
    },
    {
      label:
        data[0].company[0].healthPlan[0].lob === "HMO"
          ? "Maximum Out-of-Pocket"
          : "Maximum Out-of-Pocket<br /> In-Network",
      value: data[0].OutOfPocketMaxInNetworkAmount,
    },
    {
      label:
        data[0].company[0].healthPlan[0].lob === "HMO"
          ? "PCP Copay"
          : "PCP Copay<br /> In-Network",
      value: data[0].PCPCopayInNetworkAmount,
    },
    {
      label:
        data[0].company[0].healthPlan[0].lob === "HMO"
          ? "Specialist Copay"
          : "Specialist Copay<br /> In-Network",
      value: data[0].SpecialistCopayInNetworkAmount,
    },
  ];

  const planYear = yearsForZip.find(
    (item) => item.Year === Number(data[0].planYear)
  );

  const goEnroll = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    sessionStorage.getItem("doctorProviderID");
    const id = sessionStorage.getItem("doctorProviderID");
    window.open(enrollLink, "_blank");
  };
  return (
    <div className="background-quaternary">
      <div className="grid-container">
        <div className="grid-y" style={{ padding: "24px 20px" }}>
          <div>
            <h3 className="color-secondary text-uppercase">
              {data[0].company[0].healthPlan[0].pbp[0].name}{" "}
              {data[0].company[0].healthPlan[0].pbp[0].id}
            </h3>
          </div>
          <div
            className="grid-x grid-margin-x"
            style={{
              padding: "40px 0px",
              borderBottom: "1px solid #F5F9FD ",
            }}
          >
            {priceTilesData.map((priceTile: IPriceTile, index) => (
              <PriceTile data={priceTile} key={index} />
            ))}
          </div>
          <div className="show-for-small-only">
            <button
              type="button"
              className="button my-anchor-element enroll-button"
              disabled={!planYear?.canEnroll}
              style={{
                flex: 1,
                width: "100%",
                minHeight: "60px",
                marginRight: 8,
                backgroundColor: !planYear?.canEnroll ? "#CACACA" : "",
              }}
              onClick={goEnroll}
            >
              Enroll
            </button>
            {!planYear?.canEnroll && planYear?.shouldDisplay && (
              <Tooltip
                anchorSelect=".enroll-button"
                place="top"
                style={{
                  width: "75%",
                  maxWidth: "600px",
                  backgroundColor: "#F5F9FD",
                  color: "black",
                  padding: 28,
                }}
              >
                <EnrollTooltip />
              </Tooltip>
            )}
          </div>
          <div className="hide-for-small-only">
            <button
              type="button"
              className="button my-anchor-element enroll-button"
              disabled={!planYear?.canEnroll}
              style={{
                flex: 1,
                minHeight: "60px",
                minWidth: "260px",
                marginRight: 8,
                backgroundColor: !planYear?.canEnroll ? "#CACACA" : "",
              }}
              onClick={goEnroll}
            >
              Enroll
            </button>
            {!planYear?.canEnroll && planYear?.shouldDisplay && (
              <Tooltip
                anchorSelect=".enroll-button"
                place="top"
                style={{
                  width: "75%",
                  maxWidth: "600px",
                  backgroundColor: "#F5F9FD",
                  color: "black",
                  padding: 28,
                }}
              >
                <EnrollTooltip />
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderDetails;
